<template>
  <div
    class="d-flex flex-column align-center"
    style="width: 250px"
  >
    <div class="text-h6 black--text font-weight-bold mt-5">
      {{ channel.name }}
    </div>
    <canvas ref="whatsAppCanvas"></canvas>
    <v-btn
      class="whatsAppBtn"
      color="#25d366"
      :href="channel.connectionString"
      target="_blank"
      ><v-icon
        color="white"
        class="mr-2"
        >mdi-whatsapp</v-icon
      >
      <span class="white--text">Open WhatsApp Chat</span></v-btn
    >
  </div>
</template>

<script>
import QRCode from 'qrcode';
export default {
  name: 'WhatsAppButton',
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.createQRCode();
  },
  methods: {
    async createQRCode() {
      let whatsAppCanvas = this.$refs.whatsAppCanvas;
      await QRCode.toCanvas(whatsAppCanvas, this.channel.connectionString, {
        width: 270,
      });
    },
  },
};
</script>
